<template>
  <div :class="['countdown-block', type]">
    <div class="wrap">
      <h4 class="countdown-title">{{ title }}</h4>
      <div class="flex-container">
        <div class="countdown-item days">
          <div class="countdown-square notranslate">{{ days }}</div>
          <div class="countdown-description">
            {{ $t('campaignLandingPage.countDown.days') }}
          </div>
        </div>
        <div class="countdown-item hours">
          <div class="countdown-square notranslate">{{ hours }}</div>
          <div class="countdown-description">
            {{ $t('campaignLandingPage.countDown.hours') }}
          </div>
        </div>
        <div class="countdown-item minutes">
          <div class="countdown-square notranslate">{{ minutes }}</div>
          <div class="countdown-description">
            {{ $t('campaignLandingPage.countDown.minutes') }}
          </div>
        </div>
        <div class="countdown-item seconds">
          <div class="countdown-square notranslate">{{ seconds }}</div>
          <div class="countdown-description">
            {{ $t('campaignLandingPage.countDown.seconds') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment-timezone'

  const TIMEZONE_RIGA = 'Europe/Riga'

  export default {
    props: {
      deadline: {
        type: Object,
        default: () => {}
      },
      title: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'gray',
        validator: function (value) {
          return ['gray', 'green'].indexOf(value) !== -1
        }
      }
    },

    data() {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        msInDay: 86400000, // hours*minutes*seconds*milliseconds
        msInHour: 60 * 60 * 1000, // hours*minutes*seconds*milliseconds
        msInMinute: 60 * 1000, // hours*minutes*seconds*milliseconds
        msInSecond: 1000, // hours*minutes*seconds*milliseconds
        timer: null
      }
    },
    computed: {
      ...mapState('main', ['selectedLang'])
    },
    mounted() {
      const that = this
      that.timer = setInterval(() => {
        that.showTimer()
      }, 1000)
    },

    methods: {
      showTimer() {
        const now = moment.tz(TIMEZONE_RIGA)
        const target = moment.tz(
          moment(this.deadline).format('YYYY-MM-DD HH:mm:ss'),
          TIMEZONE_RIGA
        )
        const duration = moment.duration(target.diff(now))

        if (duration.asSeconds() <= 0) {
          clearInterval(this.timer)
          this.days = this.hours = this.minutes = this.seconds = 0
          return
        }

        this.days = Math.floor(duration.asDays())
        this.hours = Math.floor(duration.hours())
        this.minutes = Math.floor(duration.minutes())
        this.seconds = Math.floor(duration.seconds())
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';

  .countdown-block {
    padding: 16px 31px;
    background-color: $gray-marble;
    text-align: center;

    @include bp-mf-tablet {
      background-color: white;
      border-radius: 6px;
      box-shadow: 0 2px 30px rgba(60, 64, 82, 0.11);
    }
  }

  .countdown-title {
    margin: 0 0 10px;
    font-weight: 500;
  }

  .countdown-item {
    display: inline-block;
  }

  .countdown-description {
    padding-top: 10px;
    overflow: hidden;
    font-size: em(12);
    color: $grey;
  }

  .gray {
    height: 142px;

    @include bp-mf-tablet {
      width: 310px;
      margin: 0 auto 15px;
    }

    .countdown-square {
      width: 57px;
      height: 57px;
      background-color: #5d5e8e;
      border-radius: 6px;
      font-size: em(30);
      font-weight: 700;
      line-height: 59px;
      color: white;
    }
  }

  .green {
    background-color: white;
    box-shadow: none;
    padding: 16px 0;
    margin: 0 20px;

    @include bp-mf-desktop {
      margin: 0 auto;
    }

    .wrap {
      max-width: 281px;
      margin: 0 auto;

      @include bp-mf-tablet {
        max-width: 320px;
        padding: 0;
      }
    }

    .countdown-title {
      color: $blue-dark;
      font-size: em(20);
      font-weight: 500;
      margin: 0 0 18px;
    }

    .flex-container {
      display: flex;
      justify-content: space-between;
    }

    .countdown-item {
      width: 24%;
    }

    .countdown-square {
      max-width: 65px;
      height: 65px;
      line-height: 65px;
      background-color: $green-base;
      border-radius: 4px;
      color: $blue-dark;
      font-weight: 500;
      font-size: em(32);
      letter-spacing: 0;

      @include bp-mf-tablet {
        height: 74px;
        max-width: 74px;
        line-height: 74px;
        font-size: em(40);
      }
    }

    .countdown-description {
      color: $text-secondary;
    }
  }
</style>
